// Snapshot meta stores the gzipped S3 size; ~6MB gzipped is roughly 50MB of
// JSON, past which a browser tab struggles and viewing yields to download.
export const SNAPSHOT_VIEW_MAX_GZIP_BYTES = 6 * 1024 * 1024;

export const openTextInTab = content => {
  const blobUrl = URL.createObjectURL(new Blob([content], { type: 'text/plain' }));
  window.open(blobUrl, '_blank', 'noopener');
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60 * 1000);
};

// Stored artifacts are compact JSON; viewing pretty-prints while downloads stay byte-identical.
export const openJsonInTab = content => {
  try {
    openTextInTab(JSON.stringify(JSON.parse(content), null, 2));
  } catch {
    openTextInTab(content);
  }
};

export const downloadTextFile = (filename, content) => {
  const blobUrl = URL.createObjectURL(new Blob([content], { type: 'text/plain' }));
  const anchor = document.createElement('a');
  anchor.href = blobUrl;
  anchor.download = filename;
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60 * 1000);
};
